import ErrorComponent from '@kaidam/fc-shared/src/frontend/components/system/Error'
export default ErrorComponent